import React from 'react';
import ReactDOM from 'react-dom';
const { Icon, Card, Button } = window;
/* ============================================================
   BOOKER — Tela: Alvarás (visão de COBERTURA)
   Todas as empresas × alvarás (match por CNPJ): quem tem e quem não tem.
   ============================================================ */
var { useState, useEffect, useMemo } = React;

const fmtData = (iso) => (iso ? window.DB.fmtData(iso) : '—');

// Máscara de CNPJ enquanto digita: 00.000.000/0000-00 (limita a 14 dígitos).
function maskCnpj(v) {
  return String(v || '')
    .replace(/\D/g, '')
    .slice(0, 14)
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
}

// badge da situação do alvará da empresa
function sitBadge(situacao) {
  if (situacao === 'Válido') return { cor: 'var(--ok)', bg: 'var(--info-bg)' };
  if (situacao === 'Vencido') return { cor: 'var(--danger)', bg: 'var(--danger-bg)' };
  if (situacao === 'Sem alvará') return { cor: 'var(--booker-orange)', bg: 'var(--warn-bg)' };
  return { cor: 'var(--text-faint)', bg: 'var(--surface-inset)' }; // Sem data
}
// prazo (data) para empresas COM alvará
function prazo(e) {
  if (!e.temAlvara) return { txt: '—', cor: 'var(--text-faint)' };
  if (!e.vencimento) return { txt: 'Sem data', cor: 'var(--text-faint)' };
  if (e.dias < 0) return { txt: `Venceu em ${fmtData(e.vencimento)}`, cor: 'var(--danger)' };
  if (e.dias <= 90) return { txt: `Válido até ${fmtData(e.vencimento)}`, cor: 'var(--booker-orange)' };
  return { txt: `Válido até ${fmtData(e.vencimento)}`, cor: 'var(--ok)' };
}

function Alvaras() {
  const [estado, setEstado] = useState('carregando');
  const [empresas, setEmpresas] = useState([]);
  const [orfaos, setOrfaos] = useState([]);
  const [erro, setErro] = useState('');
  const [busca, setBusca] = useState('');
  const [fGrupo, setFGrupo] = useState('all');
  const [fStatus, setFStatus] = useState('all');
  const [excluindo, setExcluindo] = useState('');
  const [editando, setEditando] = useState(null);
  const [vincular, setVincular] = useState(null);
  const [obsAlvara, setObsAlvara] = useState(null);
  const [pend, setPend] = useState([]);      // arquivos no SharePoint ainda não importados
  const [pastaUrl, setPastaUrl] = useState('');
  const [sincronizando, setSincronizando] = useState(false);
  const [importandoMassa, setImportandoMassa] = useState(false);
  const [progresso, setProgresso] = useState(null);   // { i, total } durante a importação em massa
  const podeEditar = window.podeEditar ? window.podeEditar() : true;

  async function carregar() {
    setEstado('carregando'); setErro('');
    try { const d = await window.Api.apiAlvarasCobertura(); setEmpresas(d.empresas || []); setOrfaos(d.orfaos || []); setEstado('ok'); }
    catch (e) { setErro(e.message || 'Falha ao carregar'); setEstado('erro'); }
    window.Api.apiSharepointPendentes('alvaras').then(d => { setPend((d && d.pendentes) || []); setPastaUrl((d && d.pastaUrl) || ''); }).catch(() => setPend([]));
  }
  useEffect(() => { carregar(); }, []);

  async function sincronizar() {
    setSincronizando(true);
    try {
      const r = await window.Api.apiSharepointSincronizar('alvaras');
      if (r && r.ok) window.avisar(`Sincronizado! ${r.ligados} ligado(s), ${r.religados} religado(s)` + (r.novos ? `, ${r.novos} novo(s) a revisar` : '') + '.');
      else window.avisar((r && r.erro) || 'Falha ao sincronizar.');
      carregar();
    } catch (e) { window.avisar(e.message); }
    finally { setSincronizando(false); }
  }
  async function importarPend(p) {
    try {
      const r = await window.Api.apiSharepointImportar(p.id);
      window.avisar(r.tipoDoc === 'alvara' ? 'Alvará importado! ✅' + (r.revisar ? ' (a revisar — sem CNPJ/vencimento)' : '') : 'Importado.');
      carregar();
    } catch (e) { window.avisar(e.message); }
  }
  async function dispensarPend(p) {
    if (!await window.confirmar(`Dispensar "${p.nome}" da lista? (não apaga do SharePoint)`)) return;
    try { await window.Api.apiSharepointIgnorar(p.id); carregar(); }
    catch (e) { window.avisar(e.message); }
  }
  // Importa TODOS os pendentes de uma vez (um por um, mas sem recarregar a cada
  // um — só no fim), com progresso. Reaproveita a mesma importação individual.
  async function importarTodosPend() {
    const lista = [...pend];
    if (!lista.length) return;
    if (!await window.confirmar(`Importar de uma vez os ${lista.length} arquivos pendentes?`)) return;
    setImportandoMassa(true);
    let ok = 0, revisar = 0, falhas = 0;
    for (let i = 0; i < lista.length; i++) {
      setProgresso({ i: i + 1, total: lista.length });
      try {
        const r = await window.Api.apiSharepointImportar(lista[i].id);
        ok++;
        if (r && r.revisar) revisar++;
      } catch (e) { falhas++; }
    }
    setImportandoMassa(false); setProgresso(null);
    window.avisar(`Importação em massa concluída: ${ok} importado(s)`
      + (revisar ? `, ${revisar} a revisar` : '')
      + (falhas ? `, ${falhas} falha(s)` : '') + '.');
    carregar();
  }

  async function excluir(e) {
    if (!await window.confirmar(`Excluir permanentemente o alvará de ${e.razao}?`)) return;
    setExcluindo(e.arquivo);
    try { await window.Api.apiExcluirAlvara(e.arquivo); carregar(); }
    catch (err) { window.avisar(err.message); } finally { setExcluindo(''); }
  }
  // monta o objeto de alvará (p/ os modais) a partir da linha de cobertura
  const alvObj = (e) => ({ id: e.alvaraId, razao: e.alvaraRazao || e.razao, cnpj: e.alvaraCnpj || e.cnpj, numero: e.numero, cmc: e.cmc, emissao: e.emissao, vencimento: e.vencimento, arquivo: e.arquivo, obsCount: e.obsCount });

  const kpis = useMemo(() => ({
    total: empresas.length,
    com: empresas.filter(e => e.temAlvara).length,
    sem: empresas.filter(e => !e.temAlvara).length,
    vencidos: empresas.filter(e => e.situacao === 'Vencido').length,
  }), [empresas]);

  // Empresas que passam por TODOS os filtros MENOS o de grupo. É daqui que saem
  // as opções do dropdown de grupo (cascata: filtrando "Sem alvará", o dropdown
  // só oferece grupos que têm empresa sem alvará).
  const semFiltroGrupo = useMemo(() => {
    const q = busca.trim().toLowerCase();
    return empresas.filter(e => {
      if (fStatus === 'com' && !e.temAlvara) return false;
      if (fStatus === 'sem' && e.temAlvara) return false;
      if (fStatus === 'vencido' && e.situacao !== 'Vencido') return false;
      if (q && !((e.razao || '').toLowerCase().includes(q) || (e.cnpj || '').includes(q) || (e.grupo || '').toLowerCase().includes(q))) return false;
      return true;
    });
  }, [empresas, busca, fStatus]);

  const grupos = useMemo(() => [...new Set(semFiltroGrupo.map(e => (e.grupo || '').trim()).filter(Boolean))].sort(), [semFiltroGrupo]);

  // Se o grupo escolhido sumiu do recorte, volta para "todos" — senão a lista
  // ficaria vazia sem o usuário entender o porquê.
  useEffect(() => {
    if (fGrupo !== 'all' && !grupos.includes(fGrupo)) setFGrupo('all');
  }, [grupos, fGrupo]);

  const filtrada = useMemo(
    () => (fGrupo === 'all' ? semFiltroGrupo : semFiltroGrupo.filter(e => (e.grupo || '').trim() === fGrupo)),
    [semFiltroGrupo, fGrupo],
  );

  const selCss = { padding: '10px 14px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13.5, fontWeight: 600, outline: 'none', cursor: 'pointer' };

  return (
    <div style={{ animation: 'fadeUp .4s ease both' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 16, marginBottom: 22 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: 'var(--text-strong)', letterSpacing: '-.02em' }}>Alvarás</h1>
          <p style={{ margin: '5px 0 0', color: 'var(--text-muted)', fontSize: 14 }}>Cobertura de alvará por empresa · quem tem e quem falta</p>
          {pastaUrl && (
            <a href={pastaUrl} target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 7, fontSize: 12.5, fontWeight: 700, color: 'var(--booker-orange)', textDecoration: 'none' }}>
              <Icon name="external" size={14} /> Abrir a pasta de alvarás no SharePoint
            </a>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {podeEditar && pend.length > 0 && (
            <Button variant="default" size="md" icon="download"
              onClick={(importandoMassa || sincronizando) ? undefined : importarTodosPend}
              style={{ opacity: (importandoMassa || sincronizando) ? 0.6 : 1 }}>
              {importandoMassa ? `Importando ${progresso ? progresso.i : ''}/${progresso ? progresso.total : pend.length}…` : `Importar em massa (${pend.length})`}
            </Button>
          )}
          {podeEditar
            ? <Button variant="accent" size="md" icon="refresh" onClick={importandoMassa ? undefined : sincronizar} style={{ opacity: importandoMassa ? 0.6 : 1 }}>{sincronizando ? 'Sincronizando…' : 'Sincronizar SharePoint'}</Button>
            : <Button variant="default" size="md" icon="refresh" onClick={carregar}>Atualizar</Button>}
        </div>
      </div>

      {pend.length > 0 && (
        <Card pad={0} style={{ marginBottom: 16, border: '1px solid var(--booker-orange)' }}>
          <div style={{ padding: '14px 18px 10px', display: 'flex', alignItems: 'center', gap: 10 }}>
            <Icon name="link" size={17} style={{ color: 'var(--booker-orange)' }} />
            <h3 style={{ margin: 0, fontSize: 14.5, fontWeight: 800, color: 'var(--text-strong)' }}>No SharePoint, ainda não importados</h3>
            <span style={{ background: 'var(--warn-bg)', color: 'var(--booker-orange)', fontWeight: 800, fontSize: 12, padding: '2px 8px', borderRadius: 99 }}>{pend.length}</span>
          </div>
          {pend.map(p => (
            <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '11px 18px', borderTop: '1px solid var(--border)' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.nome}</div>
                <div style={{ fontSize: 11, color: 'var(--booker-orange)', fontWeight: 700 }}>Arquivo novo na pasta de alvarás</div>
              </div>
              <Button size="sm" variant="ghost" icon="external" onClick={() => window.Api.abrirSharepoint(p.id).catch(e => window.avisar(e.message))}>Abrir</Button>
              {podeEditar && <Button size="sm" variant="accent" icon="download" onClick={importandoMassa ? undefined : () => importarPend(p)} style={{ opacity: importandoMassa ? 0.5 : 1 }}>Importar</Button>}
              {podeEditar && <Button size="sm" variant="ghost" icon="x" onClick={importandoMassa ? undefined : () => dispensarPend(p)} style={{ opacity: importandoMassa ? 0.5 : 1 }}>Dispensar</Button>}
            </div>
          ))}
        </Card>
      )}

      {estado === 'ok' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 18 }}>
          <Kpi label="Empresas" value={kpis.total} tone="var(--text-strong)" />
          <Kpi label="Com alvará" value={kpis.com} tone="var(--ok)" />
          <Kpi label="Sem alvará" value={kpis.sem} tone="var(--booker-orange)" />
          <Kpi label="Vencidos" value={kpis.vencidos} tone="var(--danger)" />
        </div>
      )}

      {estado === 'ok' && (
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
          <div style={{ position: 'relative', flex: '1 1 260px', maxWidth: 380 }}>
            <Icon name="search" size={17} style={{ position: 'absolute', left: 13, top: 11, color: 'var(--text-muted)' }} />
            <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar empresa, CNPJ ou grupo…"
              style={{ width: '100%', padding: '10px 12px 10px 40px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13.5, outline: 'none' }} />
          </div>
          <select value={fStatus} onChange={e => setFStatus(e.target.value)} style={selCss}>
            <option value="all">Todos</option>
            <option value="com">Com alvará</option>
            <option value="sem">Sem alvará</option>
            <option value="vencido">Vencidos</option>
          </select>
          <select value={fGrupo} onChange={e => setFGrupo(e.target.value)} style={selCss}>
            <option value="all">Todos os grupos ({grupos.length})</option>
            {grupos.map(g => <option key={g} value={g}>{g}</option>)}
          </select>
        </div>
      )}

      {/* Alvarás sem empresa correspondente — logo abaixo dos filtros, só quando houver */}
      {estado === 'ok' && orfaos.length > 0 && (
        <Card pad={16} style={{ marginBottom: 16, border: '1px solid var(--booker-orange)' }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--booker-orange)', marginBottom: 8 }}>⚠ Alvarás sem empresa correspondente ({orfaos.length})</div>
          {orfaos.map(o => (
            <div key={o.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', fontSize: 12.5 }}>
              <span style={{ flex: 1, color: 'var(--text-strong)' }}>{o.razao || o.arquivo}</span>
              <span className="mono" style={{ color: 'var(--text-muted)' }}>{o.cnpj || 'sem CNPJ'}</span>
              <Button size="sm" variant="ghost" icon="external" onClick={() => window.Api.abrirAlvara(o.arquivo)}>Abrir</Button>
              {podeEditar && <Button size="sm" variant="ghost" icon="edit" onClick={() => setEditando({ id: o.id, razao: o.razao, cnpj: o.cnpj, vencimento: o.vencimento, numero: '', cmc: '', emissao: '' })}>Editar</Button>}
              {podeEditar && <Button size="sm" variant="accent" icon="link" onClick={() => setVincular(o)}>Vincular empresa</Button>}
            </div>
          ))}
        </Card>
      )}

      {estado === 'carregando' && (
        <Card pad={40} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
          <span style={{ width: 34, height: 34, border: '4px solid var(--surface-inset)', borderTopColor: 'var(--booker-orange)', borderRadius: 99, display: 'inline-block', animation: 'spin .8s linear infinite' }} />
          <div style={{ marginTop: 14, fontSize: 14 }}>Carregando cobertura…</div>
        </Card>
      )}
      {estado === 'erro' && (
        <Card pad={28} style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <span style={{ width: 44, height: 44, borderRadius: 12, background: 'var(--danger-bg)', color: 'var(--danger)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="alert" size={22} /></span>
          <div style={{ flex: 1 }}><div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-strong)' }}>Não foi possível carregar</div><div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 3 }}>{erro}</div></div>
          <Button variant="default" onClick={carregar}>Tentar de novo</Button>
        </Card>
      )}

      {estado === 'ok' && (
        <Card pad={0} style={{ overflow: 'hidden' }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13.5 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--border)', textAlign: 'left' }}>
                  <Th>Empresa</Th><Th>CNPJ</Th><Th>Alvará</Th><Th>Prazo</Th><Th>Obs</Th><Th right>Ações</Th>
                </tr>
              </thead>
              <tbody>
                {filtrada.map((e, i) => {
                  const sb = sitBadge(e.situacao); const pz = prazo(e);
                  return (
                    <tr key={e.empresaId} style={{ borderTop: i ? '1px solid var(--border)' : 'none' }}>
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ fontWeight: 600, color: 'var(--text-strong)' }}>{e.razao || '—'}</div>
                        <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 2 }}>{e.grupo || '—'}{e.papel === 'matriz' ? ' · matriz' : ''}</div>
                      </td>
                      <td style={{ padding: '12px 16px' }} className="mono">{e.cnpj || '—'}</td>
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{ fontSize: 12, fontWeight: 700, color: sb.cor, background: sb.bg, padding: '3px 10px', borderRadius: 99, whiteSpace: 'nowrap' }}>{e.situacao}</span>
                      </td>
                      <td style={{ padding: '12px 16px', fontWeight: 600, color: pz.cor, whiteSpace: 'nowrap' }}>{pz.txt}</td>
                      <td style={{ padding: '12px 16px' }}>
                        {e.temAlvara ? (
                          <button onClick={() => setObsAlvara(alvObj(e))} title="Observações"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '5px 10px', borderRadius: 99, border: '1px solid var(--border)', background: e.obsCount ? 'var(--info-bg)' : 'var(--surface)', color: e.obsCount ? 'var(--info)' : 'var(--text-muted)', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                            <Icon name="eye" size={15} />{e.obsCount ? e.obsCount : ''}
                          </button>
                        ) : <span style={{ color: 'var(--text-faint)' }}>—</span>}
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                          {e.temAlvara ? (
                            <>
                              {podeEditar && <Button size="sm" variant="ghost" icon="edit" onClick={() => setEditando(alvObj(e))}>Editar</Button>}
                              <Button size="sm" variant="ghost" icon="external" onClick={() => window.Api.abrirAlvara(e.arquivo)}>Abrir</Button>
                              {podeEditar && <button onClick={() => excluir(e)} title="Excluir" style={{ width: 32, height: 32, borderRadius: 7, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--danger)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                <Icon name="trash" size={15} />
                              </button>}
                            </>
                          ) : (
                            <span style={{ color: 'var(--text-faint)' }}>—</span>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ padding: '10px 16px', fontSize: 12, color: 'var(--text-muted)', borderTop: '1px solid var(--border)' }}>{filtrada.length} de {empresas.length} empresas</div>
        </Card>
      )}

      {estado === 'ok' && filtrada.length === 0 && empresas.length > 0 && (
        <Card pad={28} style={{ textAlign: 'center', color: 'var(--text-muted)', marginTop: 12 }}>Nenhuma empresa para o filtro.</Card>
      )}

      {editando && <EditarAlvara a={editando} onClose={() => setEditando(null)} onSaved={() => { setEditando(null); carregar(); }} />}
      {vincular && <VincularEmpresa orfao={vincular} empresas={empresas} onClose={() => setVincular(null)} onSaved={() => { setVincular(null); carregar(); }} />}
      {obsAlvara && <ObservacoesAlvara a={obsAlvara} onClose={() => setObsAlvara(null)} onChanged={carregar} />}
    </div>
  );
}

function EditarAlvara({ a, onClose, onSaved }) {
  const [form, setForm] = useState({
    razao_social: a.razao || '', cnpj: maskCnpj(a.cnpj || ''), numero: a.numero || '', cmc: a.cmc || '',
    emissao: a.emissao || '', vencimento: a.vencimento || '',
  });
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const set = (c) => (e) => setForm(f => ({ ...f, [c]: e.target.value }));
  async function salvar() {
    setErro(''); setSalvando(true);
    try { await window.Api.apiEditarAlvara(a.id, form); onSaved(); }
    catch (e) { setErro(e.message); setSalvando(false); }
  }
  const campo = { width: '100%', padding: '9px 11px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13.5, outline: 'none' };
  const Label = ({ children }) => <label style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>{children}</label>;
  return ReactDOM.createPortal(
    <div onClick={salvando ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 100, animation: 'fadeIn .2s ease both', padding: '40px 20px', overflowY: 'auto' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto', background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: '1px solid var(--border)' }}>
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: 'var(--text-strong)' }}>Editar alvará</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', padding: 4 }}><Icon name="x" size={18} /></button>
        </div>
        <div style={{ padding: 22 }}>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 14, wordBreak: 'break-all' }}>Arquivo: <span className="mono">{a.arquivo}</span></div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <div style={{ gridColumn: '1 / -1' }}><Label>Razão social</Label><input style={campo} value={form.razao_social} onChange={set('razao_social')} /></div>
            <div><Label>CNPJ</Label><input style={campo} value={form.cnpj} onChange={e => setForm(f => ({ ...f, cnpj: maskCnpj(e.target.value) }))} placeholder="00.000.000/0000-00" inputMode="numeric" /></div>
            <div><Label>Nº Alvará/Ano</Label><input style={campo} value={form.numero} onChange={set('numero')} /></div>
            <div><Label>Emissão</Label><input style={campo} type="date" value={form.emissao} onChange={set('emissao')} /></div>
            <div><Label>Vencimento</Label><input style={campo} type="date" value={form.vencimento} onChange={set('vencimento')} /></div>
          </div>
          {erro && <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 14, padding: '10px 13px', background: 'var(--danger-bg)', color: 'var(--danger)', borderRadius: 'var(--r-sm)', fontSize: 12.5, fontWeight: 600 }}><Icon name="alert" size={15} /> {erro}</div>}
          <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
            <Button variant="default" onClick={onClose} style={{ flex: 1, justifyContent: 'center' }}>Cancelar</Button>
            <Button variant="accent" icon={salvando ? undefined : 'check'} onClick={salvando ? undefined : salvar} style={{ flex: 1.4, justifyContent: 'center' }}>{salvando ? 'Salvando…' : 'Salvar'}</Button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

// Vínculo manual: escolhe a empresa do cadastro (sem digitar CNPJ). Aplica o
// CNPJ da empresa ao alvará — o backend recalcula o match na hora.
function VincularEmpresa({ orfao, empresas, onClose, onSaved }) {
  const [busca, setBusca] = useState('');
  const [salvando, setSalvando] = useState(null);
  const [erro, setErro] = useState('');
  const lista = useMemo(() => {
    const vistos = new Set(), uniq = [];
    for (const e of empresas) { if (e.empresaId && !vistos.has(e.empresaId)) { vistos.add(e.empresaId); uniq.push(e); } }
    const q = busca.trim().toLowerCase();
    return uniq
      .filter(e => !q || (e.razao || '').toLowerCase().includes(q) || (e.cnpj || '').includes(q) || (e.grupo || '').toLowerCase().includes(q))
      .sort((a, b) => (a.razao || '').localeCompare(b.razao || ''));
  }, [empresas, busca]);

  async function escolher(e) {
    if (salvando) return;
    setErro(''); setSalvando(e.empresaId);
    try { await window.Api.apiEditarAlvara(orfao.id, { cnpj: e.cnpj }); onSaved(); }
    catch (err) { setErro(err.message || 'Falha ao vincular'); setSalvando(null); }
  }

  const campo = { width: '100%', padding: '10px 12px 10px 38px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13.5, outline: 'none' };
  return ReactDOM.createPortal(
    <div onClick={salvando ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 100, animation: 'fadeIn .2s ease both', padding: '40px 20px', overflowY: 'auto' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 520, maxHeight: '90vh', display: 'flex', flexDirection: 'column', background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: '1px solid var(--border)' }}>
          <div>
            <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: 'var(--text-strong)' }}>Vincular a uma empresa</h3>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 3, wordBreak: 'break-all' }}>{orfao.razao || orfao.arquivo}</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', padding: 4 }}><Icon name="x" size={18} /></button>
        </div>
        <div style={{ padding: '16px 22px 0' }}>
          <div style={{ position: 'relative' }}>
            <Icon name="search" size={16} style={{ position: 'absolute', left: 13, top: 12, color: 'var(--text-muted)' }} />
            <input autoFocus value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar empresa por nome, CNPJ ou grupo…" style={campo} />
          </div>
          {erro && <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 12, padding: '10px 13px', background: 'var(--danger-bg)', color: 'var(--danger)', borderRadius: 'var(--r-sm)', fontSize: 12.5, fontWeight: 600 }}><Icon name="alert" size={15} /> {erro}</div>}
        </div>
        <div style={{ padding: '12px 14px 18px', overflowY: 'auto' }}>
          {lista.length === 0 && (
            <div style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: 13, padding: '24px 12px' }}>
              Nenhuma empresa encontrada.<br />Se ela ainda não existe, cadastre primeiro na aba <b>Empresas</b>.
            </div>
          )}
          {lista.map(e => (
            <button key={e.empresaId} onClick={() => escolher(e)} disabled={!!salvando}
              style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', marginBottom: 4, borderRadius: 'var(--r-sm)', border: '1px solid var(--border)', background: salvando === e.empresaId ? 'var(--info-bg)' : 'var(--surface-2)', cursor: salvando ? 'wait' : 'pointer', textAlign: 'left' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{e.razao}{e.grupo ? <span style={{ color: 'var(--text-faint)', fontWeight: 600 }}> · {e.grupo}</span> : ''}</div>
                <div className="mono" style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{e.cnpj}{e.temAlvara ? ' · já tem alvará' : ''}</div>
              </div>
              {salvando === e.empresaId
                ? <span style={{ width: 15, height: 15, border: '2px solid var(--info)', borderTopColor: 'transparent', borderRadius: 99, animation: 'spin .7s linear infinite' }} />
                : <Icon name="link" size={16} style={{ color: 'var(--booker-orange)', flexShrink: 0 }} />}
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}

function Th({ children, right }) {
  return <th style={{ padding: '12px 16px', fontSize: 11.5, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', textAlign: right ? 'right' : 'left' }}>{children}</th>;
}
function Kpi({ label, value, tone }) {
  return (
    <Card pad={16}>
      <div style={{ fontSize: 28, fontWeight: 800, color: tone, letterSpacing: '-.02em', lineHeight: 1 }} className="tnum">{value}</div>
      <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text-muted)', marginTop: 6 }}>{label}</div>
    </Card>
  );
}

function ObservacoesAlvara({ a, onClose, onChanged }) {
  const [lista, setLista] = useState(null);
  const [texto, setTexto] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  async function carregar() {
    try { setLista(await window.Api.apiAlvaraObsList(a.id)); }
    catch (e) { setErro(e.message); setLista([]); }
  }
  useEffect(() => { carregar(); }, []);
  async function adicionar() {
    const t = texto.trim();
    if (!t) return;
    setSalvando(true); setErro('');
    try { setLista(await window.Api.apiAlvaraObsAdd(a.id, t)); setTexto(''); if (onChanged) onChanged(); }
    catch (e) { setErro(e.message); }
    finally { setSalvando(false); }
  }
  async function excluir(id) {
    if (!await window.confirmar('Excluir esta observação do histórico?')) return;
    try { await window.Api.apiAlvaraObsDel(id); await carregar(); if (onChanged) onChanged(); }
    catch (e) { setErro(e.message); }
  }
  const fmtDH = (iso) => { try { return new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }); } catch { return '—'; } };
  const campo = { width: '100%', padding: '9px 11px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13.5, outline: 'none' };
  return ReactDOM.createPortal(
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 100, animation: 'fadeIn .2s ease both', padding: '40px 20px', overflowY: 'auto' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 560, maxHeight: '88vh', display: 'flex', flexDirection: 'column', background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both', overflow: 'hidden' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
            <Icon name="eye" size={19} style={{ color: 'var(--booker-orange)', flexShrink: 0 }} />
            <div style={{ minWidth: 0 }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800, color: 'var(--text-strong)' }}>Observações</h3>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.razao || a.arquivo}</div>
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', padding: 4 }}><Icon name="x" size={18} /></button>
        </div>
        <div style={{ padding: '16px 22px', borderBottom: '1px solid var(--border)' }}>
          <textarea value={texto} onChange={e => setTexto(e.target.value)} placeholder="Nova observação · ex.: em renovação, pendente de documento do cliente, aguardando taxa…"
            style={{ ...campo, minHeight: 64, resize: 'vertical', fontFamily: 'inherit' }} />
          {erro && <div style={{ color: 'var(--danger)', fontSize: 12, marginTop: 6 }}>{erro}</div>}
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
            <Button variant="accent" icon={salvando ? undefined : 'plus'} onClick={salvando ? undefined : adicionar}>{salvando ? 'Salvando…' : 'Adicionar observação'}</Button>
          </div>
        </div>
        <div style={{ padding: '8px 22px 18px', overflowY: 'auto', flex: 1 }}>
          <div style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', padding: '10px 0 6px' }}>Histórico</div>
          {lista === null ? (
            <div style={{ color: 'var(--text-muted)', fontSize: 13, padding: '10px 0' }}>Carregando…</div>
          ) : lista.length === 0 ? (
            <div style={{ color: 'var(--text-faint)', fontSize: 13, padding: '14px 0', textAlign: 'center' }}>Nenhuma observação ainda.</div>
          ) : lista.map(o => (
            <div key={o.id} style={{ display: 'flex', gap: 11, padding: '11px 0', borderTop: '1px solid var(--border)' }}>
              <span style={{ width: 7, height: 7, borderRadius: 99, background: 'var(--booker-orange)', flexShrink: 0, marginTop: 6 }} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13.5, color: 'var(--text-strong)', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{o.texto}</div>
                <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 3 }}>por <b style={{ color: 'var(--text)' }}>{o.por}</b> · {fmtDH(o.em)}</div>
              </div>
              <button onClick={() => excluir(o.id)} title="Excluir" style={{ width: 28, height: 28, borderRadius: 7, border: 'none', background: 'transparent', color: 'var(--text-faint)', flexShrink: 0, cursor: 'pointer' }}><Icon name="trash" size={14} /></button>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}

Object.assign(window, { Alvaras });
